export default function PrintHeader({ title, subtitle }) {
  return (
    <div className="print-header" data-testid="print-header">
      <div className="tricolor" style={{ height: 8 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 12 }}>
        <img src="/logo.png" alt="Logo Republique Gabonaise" style={{ height: 64 }} />
        <div>
          <p style={{ fontWeight: 800, fontSize: 20, letterSpacing: 2 }}>ALARA</p>
          <p style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, color: "#009E60" }}>
            Republique Gabonaise
          </p>
          <p style={{ fontSize: 11, color: "#334155" }}>
            Ministere des Transports, de la Marine Marchande, charge de la Logistique
          </p>
        </div>
      </div>
      <h2 style={{ marginTop: 14, fontSize: 16, fontWeight: 700 }}>{title}</h2>
      {subtitle && <p style={{ fontSize: 11, color: "#475569" }}>{subtitle}</p>}
      <p style={{ fontSize: 10, color: "#64748b", marginTop: 2 }}>
        Document imprime le {new Date().toLocaleString("fr-FR")} — Union - Travail - Justice
      </p>
      <hr style={{ margin: "10px 0", borderColor: "#cbd5e1" }} />
    </div>
  );
}
